import { render, staticRenderFns } from "./newSearchComponent.vue?vue&type=template&id=fd6072f0"
import script from "./newSearchComponent.vue?vue&type=script&lang=js"
export * from "./newSearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports